/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_FAQ_REQUEST,
  GET_FAQ_SUCCESS,
  GET_FAQ_FAILURE,
  GET_FAQ_DETAILS_REQUEST,
  GET_FAQ_DETAILS_SUCCESS,
  GET_FAQ_DETAILS_FAILURE,
} from "./faqTypes";

import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
// let baseUrl = `http://13.71.2.248:1338/api/v2/users_management`;

const getFaqRequest = () => {
  return {
    type: GET_FAQ_REQUEST,
  };
};

const getFaqSuccess = (payload) => {
  return {
    type: GET_FAQ_SUCCESS,
    payload: payload,
  };
};

const getFaqFaliure = (error) => {
  return {
    type: GET_FAQ_FAILURE,
    payload: error,
  };
};

const getFaq = (name, type, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFaqRequest());
    let url = `${baseUrl}/faq/get_doc?file_name=${name}&file_type=${type}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFaqSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFaqFaliure(err.response));
      });
  };
};

const getFaqDetailsRequest = () => {
  return {
    type: GET_FAQ_DETAILS_REQUEST,
  };
};

const getFaqDetailsSuccess = (payload) => {
  return {
    type: GET_FAQ_DETAILS_SUCCESS,
    payload: payload,
  };
};

const getFaqDetailsFaliure = (error) => {
  return {
    type: GET_FAQ_DETAILS_FAILURE,
    payload: error,
  };
};

const getFaqDetails = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFaqDetailsRequest());
    let url = `${baseUrl}/faq/get`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFaqDetailsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFaqDetailsFaliure(err.response));
      });
  };
};

export { getFaq, getFaqDetails };
